var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading',{attrs:{"color":"rgb(187, 57, 54)","active":_vm.showLoading},on:{"update:active":function($event){_vm.showLoading=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }